module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter1#chapter1"
    }
  }, [_c('big', [_vm._v("1")]), _vm._v("   Alaska: Resurrection Bay")], 1)]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter2#chapter2"
    }
  }, [_c('big', [_vm._v("2")]), _vm._v("   Antarctica: Antarctic Peninsula")], 1)]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter3#chapter3"
    }
  }, [_c('big', [_vm._v("3")]), _vm._v("   Antigua and Barbuda: Antigua")], 1)]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter4#chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("4")]), _vm._v("   Australia: Fremantle")], 1)]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter5#chapter5",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("5")]), _vm._v("   Australia: Sydney")], 1)]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter6#chapter6",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("6")]), _vm._v("   Bermuda: St. George’s Harbor")], 1)]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter7#chapter7",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("7")]), _vm._v("   Brazil: Bay of Ilha Grande")], 1)]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter8#chapter8",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("8")]), _vm._v("   California: Channel Islands")], 1)]), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter9#chapter9",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("9")]), _vm._v("   California: San Francisco Bay")], 1)]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter10#chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("10")]), _vm._v("   Chile: Cape Horn")], 1)]), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter11#chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("11")]), _vm._v("   China: Hong Kong")], 1)]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter12#chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("12")]), _vm._v("   Colorado: Lake Dillon")], 1)]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter13#chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("13")]), _vm._v("   Connecticut: Eastern Long Island Sound")], 1)]), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter14#chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("14")]), _vm._v("   Croatia: Dalmatian Coast")], 1)]), _vm._v(" "), _vm._m(18), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter15#chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("15")]), _vm._v("   Ecuador: The Galápagos")], 1)]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter16#chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("16")]), _vm._v("   Florida: Biscayne Bay")], 1)]), _vm._v(" "), _vm._m(20), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter17#chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("17")]), _vm._v("   Florida: Key West")], 1)]), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter18#chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("18")]), _vm._v("   France: Hyères")], 1)]), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter19#chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("19")]), _vm._v("   French Polynesia: Mopelia")], 1)]), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter20#chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("20")]), _vm._v("   Greece: Dodecanese Islands")], 1)]), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter21#chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("21")]), _vm._v("   Hawaii: Lahaina to Honolulu")], 1)]), _vm._v(" "), _vm._m(25), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter22#chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("22")]), _vm._v("   Illinois: Chicago (Lake Michigan)")], 1)]), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter23#chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("23")]), _vm._v("   Italy: Costa Smeralda, Sardinia")], 1)]), _vm._v(" "), _vm._m(27), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter24#chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("24")]), _vm._v("   Maine: Boothbay Harbor")], 1)]), _vm._v(" "), _vm._m(28), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter25#chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("25")]), _vm._v("   Maine: Penobscot Bay")], 1)]), _vm._v(" "), _vm._m(29), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter26#chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("26")]), _vm._v("   Maine: Southwest Harbor")], 1)]), _vm._v(" "), _vm._m(30), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter27#chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("27")]), _vm._v("   Maryland: Annapolis")], 1)]), _vm._v(" "), _vm._m(31), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter28#chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("28")]), _vm._v("   Massachusetts: Buzzards Bay")], 1)]), _vm._v(" "), _vm._m(32), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter29#chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("29")]), _vm._v("   Massachusetts: Marblehead")], 1)]), _vm._v(" "), _vm._m(33), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter30#chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("30")]), _vm._v("   Mexico: Baja California Sur")], 1)]), _vm._v(" "), _vm._m(34), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter31#chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("31")]), _vm._v("   New York: New York Harbor")], 1)]), _vm._v(" "), _vm._m(35), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter32#chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("32")]), _vm._v("   New Zealand: Auckland")], 1)]), _vm._v(" "), _vm._m(36), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter33#chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("33")]), _vm._v("   Norway: Spitsbergen")], 1)]), _vm._v(" "), _vm._m(37), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter34#chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("34")]), _vm._v("   Nova Scotia: Bras d’Or Lake")], 1)]), _vm._v(" "), _vm._m(38), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter35#chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("35")]), _vm._v("   Ontario: Lake Huron’s North Channel")], 1)]), _vm._v(" "), _vm._m(39), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter36#chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("36")]), _vm._v("   Rhode Island: Newport")], 1)]), _vm._v(" "), _vm._m(40), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter37#chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("37")]), _vm._v("   Scotland: Firth of Clyde")], 1)]), _vm._v(" "), _vm._m(41), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter38#chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("38")]), _vm._v("   The Republic of Seychelles: The Seychelles")], 1)]), _vm._v(" "), _vm._m(42), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter39#chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("39")]), _vm._v("   South Africa: Cape Town")], 1)]), _vm._v(" "), _vm._m(43), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter40#chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("40")]), _vm._v("   Sweden: Stockholm Archipelago")], 1)]), _vm._v(" "), _vm._m(44), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter41#chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("41")]), _vm._v("   Thailand: Andaman Sea")], 1)]), _vm._v(" "), _vm._m(45), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter42#chapter42",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("42")]), _vm._v("   Tonga: Ha’apai")], 1)]), _vm._v(" "), _vm._m(46), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter43#chapter43",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("43")]), _vm._v("   Turkey: The Blue Coast")], 1)]), _vm._v(" "), _vm._m(47), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter44#chapter44",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("44")]), _vm._v("   United Kingdom: British Virgin Islands")], 1)]), _vm._v(" "), _vm._m(48), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter45#chapter45",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("45")]), _vm._v("   United Kingdom: The Solent and Beyond")], 1)]), _vm._v(" "), _vm._m(49), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter46#chapter46",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("46")]), _vm._v("   United Kingdom: South Georgia Island")], 1)]), _vm._v(" "), _vm._m(50), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter47#chapter47",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("47")]), _vm._v("   Vermont: Lake Champlain")], 1)]), _vm._v(" "), _vm._m(51), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter48#chapter48",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("48")]), _vm._v("   Vietnam: Nha Trang")], 1)]), _vm._v(" "), _vm._m(52), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter49#chapter49",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("49")]), _vm._v("   Washington: San Juan Islands")], 1)]), _vm._v(" "), _vm._m(53), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter50#chapter50",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("50")]), _vm._v("   Windward Islands: St. Vincent and the Grenadines")], 1)]), _vm._v(" "), _vm._m(54)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "toc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('strong', [_vm._v("Contents")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/frontmatter1"
    }
  }, [_vm._v("Acknowledgments")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/frontmatter2"
    }
  }, [_vm._v("Foreword")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocc"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/frontmatter3"
    }
  }, [_vm._v("Introduction")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/frontmatter4"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('strong', [_vm._v("THE DESTINATIONS")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY DEBORAH ALTERMATT")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY GARY JOBSON")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY MIKE SANDERSON")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY THOMAS A.WHIDDEN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY MATTH AYES")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY B. W. “JOR DY” WALKER")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY LIN PARDEY")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY J.J. ISLER")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY GLENN ISAACSON")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY AMANDA SWAN NEAL")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY GEORGE STROME")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY NICK IWASKOW")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY CHARLIE OLSEN AND ADMIRAL ROBERT C.OLSEN, JR.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY JONWILSON")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY AMY ULLRICH")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY SEAN FERRELL")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY BRIAN BISSELL")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY LAWRENCE WHITE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY JOHN NEAL")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY DIANE EDWARD S")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY MIKE ROTHWELL")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY JANET C. BAXTER")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY SEAN HEALEY")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY TIMOTHY S. HODGDON")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY JOHN WORTH")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY JENNIFER FRENCH")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY WILLIAM CHAMBERS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY PETER MELLO")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY NICK KIP")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY LARRY PARDEY")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY BILLY BLACK")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY PENNY WHITING")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY ONNE VAN DER WAL")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY JOHN BRYSON")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY MARK STEVENS")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY JEFF JOHNSTONE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY SANDY TAGGART")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY PENELOPE KELLIE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY MILES OSLER")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY THOMAS RAPP")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY HERB MCCORMICK")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY CARL HOSTICKA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY SUSAN MAFFEI PLOWDEN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY TANYA WHISTLER")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY ADRIAN MORGAN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY SKIP NOVAK")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY JUSTIN ASSAD")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY KEVIN QUILTY")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY TIM MEHRER")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "tocindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("   RECOMMENDED BY STEVE MASON")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0